import { useContext, useEffect, useState } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import { useTranslation } from "react-i18next";
import { Box,IconButton,TextField, Typography } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getMail, } from "../../../api/request/dashboard/dashboard";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import { getCookies } from "../../../services/Cookies";
import { updateEmail } from "../../../store/Slices/emailsSlice";

const ViewMAil = ({ open, handleClose, mail, onUpdateEmails }) => {
    const [content, setContent] = useState("");
    const { darkMode } = useContext(ThemeContext)
    const clientID = getCookies("clientId");
    const { t } = useTranslation()
    const dispatch = useDispatch();
    const navigate = useNavigate()

    useEffect(() => {
        if (mail?.id) {
            getMail(mail.id)
                .then((response) => {
                    setContent(response.data);

                    if (mail.unread) {
                        dispatch(updateEmail({ ...mail, unread: false }));
                    }
                })
                .catch((error) => {
                    console.error("Error fetching mail:", error);
                    toast.error("Failed to load mail.");
                });
        }
    }, [mail, clientID, dispatch]);


    return (
        <Box display="flex" flexDirection="column" height="100vh">
            <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1}>
                <Box display="flex" alignItems="center">
                    <IconButton onClick={handleClose}><ArrowBackIosNewIcon fontSize="small" onClick={() => navigate('/mails')} /></IconButton>
                    <Typography fontSize={18} fontWeight={600} ml={1}>{t('readMail')}</Typography>
                </Box>
            </Box>

            <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", px: 3, py: 3 }}>
                <Box>
                    <Box sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", height: "400px", display: 'flex', gap: 2, flexDirection: 'column' }}>
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr", gap: 2 }}>
                            <TextField label={t('from')} value={mail?.senderUsername || "Unknown"} fullWidth variant="outlined" InputProps={{ readOnly: true }} sx={{ marginBottom: 2, mt: 2 }} />
                            <TextField label={t('subject')} value={mail?.subject || "Unknown"} fullWidth variant="outlined" InputProps={{ readOnly: true }} sx={{ marginBottom: 2 }} />
                            <ReactQuill value={content || "Loading..."} readOnly={true} theme="bubble" style={{ height: "400px", marginBottom: "2px", color: darkMode ? "#fff" : "#000", border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }} />
                        </Box>
                    </Box>

                </Box>
            </Box>
        </Box>
    );
};

export default ViewMAil